var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1251,
    height: 438,
    fill: "none",
    viewBox: "0 0 1251 438",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#199CB5",
    d: "M1173.5 377.041c-1.66 0-3 1.343-3 3 0 1.656 1.34 3 3 3v-6ZM.5 6H237V0H.5v6ZM263 293.076h223.5v-6H263v6Zm239.5-16V16h-6v261.076h6ZM512.5 6H736V0H512.5v6ZM746 16v261.076h6V16h-6Zm16 277.076h223.5v-6H762v6Zm239.5-16V16h-6v261.076h6ZM1011.5 6H1235V0h-223.5v6ZM1245 16v351.041h6V16h-6Zm-10 361.041h-61.5v6h61.5v-6ZM247 16v131.5h6V16h-6Zm0 131.5v129.576h6V147.5h-6Zm998 219.541c0 5.522-4.48 10-10 10v6c8.84 0 16-7.164 16-16h-6ZM1235 6c5.52 0 10 4.477 10 10h6c0-8.837-7.16-16-16-16v6Zm-233.5 10c0-5.523 4.48-10 10-10V0c-8.84 0-16 7.163-16 16h6Zm-16 277.076c8.837 0 16-7.164 16-16h-6c0 5.523-4.477 10-10 10v6Zm-239.5-16c0 8.836 7.163 16 16 16v-6c-5.523 0-10-4.477-10-10h-6ZM502.5 16c0-5.523 4.477-10 10-10V0c-8.837 0-16 7.163-16 16h6Zm-16 277.076c8.837 0 16-7.164 16-16h-6c0 5.523-4.477 10-10 10v6Zm-223.5-6c-5.523 0-10-4.477-10-10h-6c0 8.836 7.163 16 16 16v-6ZM736 6c5.523 0 10 4.477 10 10h6c0-8.837-7.163-16-16-16v6ZM237 6c5.523 0 10 4.477 10 10h6c0-8.837-7.163-16-16-16v6Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#199CB5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "m1180.62 380.042-20.77-.042m-46.91 11.431 16.48.119m-16.81-23.658 16.47.119m.95 31.111-.55-38.675 9.67.069c2.57-.032 5.14.45 7.54 1.416 2.41.966 4.6 2.398 6.46 4.212a19.822 19.822 0 0 1 4.39 6.352 19.823 19.823 0 0 1 1.61 7.5c.04 2.572-.44 5.114-1.4 7.478a18.764 18.764 0 0 1-4.2 6.29 18.878 18.878 0 0 1-6.35 4.12 19.155 19.155 0 0 1-7.5 1.307l-9.67-.069Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1139.1 437.985-57.1-57.1 55.894-55.894 57.1 57.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCable);
export default __webpack_public_path__ + "static/media/cable.2f66f704bea82ffc3a0e3ce60510f4a2.svg";
export { ForwardRef as ReactComponent };